import { redirect } from "@tanstack/react-router";
import { PROTECTED_ROUTES } from "@/utils/navigation";

export const isValidEntityId = (value: number): boolean =>
  Number.isInteger(value) && value > 0;

export const guardWorkoutBlockId = ({
  athleteId,
  workoutBlockId,
}: {
  athleteId: string;
  workoutBlockId: string;
}) => {
  if (!isValidEntityId(Number(athleteId))) {
    throw redirect({ to: PROTECTED_ROUTES.ATHLETES });
  }

  if (!isValidEntityId(Number(workoutBlockId))) {
    throw redirect({
      to: PROTECTED_ROUTES.ATHLETE_DETAIL,
      params: { athleteId },
      search: { tab: "workouts" },
    });
  }
};
